import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer: React.FC = () => {
    const { isRTL } = useLanguage();

    const whatsappNumber = '+966535339904';
    const email = 'info@dawaakandna.com';

    const handleWhatsAppClick = () => {
        const message = encodeURIComponent(isRTL ? 'مرحباً، أود الاستفسار عن خدماتكم' : 'Hello, I would like to inquire about your services');
        window.open(`https://wa.me/966535339904?text=${message}`, '_blank');
    };

    return (
        <footer className={`footer ${isRTL ? 'rtl' : 'ltr'}`}>
            <div className="container">
                <div className="footer-content">
                    {/* About Section */}
                    <div className="footer-section">
                        <h3 className="footer-title">
                            {isRTL ? 'دواك وعندنا' : 'Dawak Endna'}
                        </h3>
                        <p className="footer-description">
                            {isRTL 
                                ? 'نوفر لك أفضل المنتجات الصيدلانية والعناية الصحية بجودة عالية وأسعار منافسة.'
                                : 'We provide you with the best pharmaceutical products and healthcare with high quality and competitive prices.'
                            }
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-section">
                        <h4 className="footer-heading">
                            {isRTL ? 'روابط سريعة' : 'Quick Links'}
                        </h4>
                        <ul className="footer-links">
                            <li><Link to="/">{isRTL ? 'الرئيسية' : 'Home'}</Link></li>
                            <li><Link to="/products">{isRTL ? 'المنتجات' : 'Products'}</Link></li>
                            <li><Link to="/contact">{isRTL ? 'اتصل بنا' : 'Contact Us'}</Link></li>
                            <li><Link to="/policies">{isRTL ? 'السياسات' : 'Policies'}</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-section">
                        <h4 className="footer-heading">
                            {isRTL ? 'تواصل معنا' : 'Contact Us'}
                        </h4>
                        <ul className="footer-contact">
                            <li>
                                <button onClick={handleWhatsAppClick} className="contact-item">
                                    <Phone size={18} />
                                    <span>{whatsappNumber}</span>
                                </button>
                            </li>
                            <li>
                                <a href={`mailto:${email}`} className="contact-item">
                                    <Mail size={18} />
                                    <span>{email}</span>
                                </a>
                            </li>
                            <li className="contact-item">
                                <MapPin size={18} />
                                <span>
                                    {isRTL ? 'الرياض حي اشبيليه اعلى هايبر رامز الدور الثالث' : 'Riyadh, Ishbiliyah District, Above Ramez Hypermarket, 3rd Floor'}
                                </span>
                            </li>
                        </ul>
                    </div>

                    {/* Social Media */}
                    {/* <div className="footer-section">
                        <h4 className="footer-heading">
                            {isRTL ? 'تابعنا' : 'Follow Us'}
                        </h4>
                        <div className="social-links">
                            <a href="#" className="social-link" aria-label="Facebook">
                                <Facebook size={20} />
                            </a>
                            <a href="#" className="social-link" aria-label="Instagram">
                                <Instagram size={20} />
                            </a>
                            <a href="#" className="social-link" aria-label="Twitter">
                                <Twitter size={20} />
                            </a>
                        </div>
                    </div> */}
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p className="copyright">
                        {isRTL 
                            ? `© ${new Date().getFullYear()} دواك وعندنا. جميع الحقوق محفوظة.`
                            : `© ${new Date().getFullYear()} Dawak Endna. All rights reserved.`
                        }
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
